import dayjs from "dayjs";

/**
 * Checks if the given expiry date is equal to or older than current date + 30 days.
 * @param {string} expiryDate - Date string in format YYYY-MM-DD (e.g., "2026-06-30")
 * @returns {boolean} true if expiryDate <= today + 30 days, otherwise false
 */
export function checkExpiryDate(expiryDate) {
  const todayPlus30 = dayjs().add(30, "day").startOf("day");
  const givenDate = dayjs(expiryDate, "YYYY-MM-DD").startOf("day");

  return givenDate.isSame(todayPlus30) || givenDate.isBefore(todayPlus30);
}